import { type AcceptedExtraDataType, type IDataTrackerEvent, type IEventData, sendDataTrackerEvent } from '@signaturit/data-tracker-client';
import { DataTrackerEvents } from './DataTrackerEvents';
import { EventData } from './types';

export const sendDataTrackerEventHandler = (
    typeOfEvent: DataTrackerEvents,
    eventData: EventData = {},
    extraData: AcceptedExtraDataType[] = []
): void => {
    const event: IDataTrackerEvent<IEventData<EventData>, DataTrackerEvents> = {
        event: typeOfEvent,
        data: eventData,
    };
    sendDataTrackerEvent<IEventData<EventData>, DataTrackerEvents>(event, extraData);
};